import { Box, Image, Text } from "@mantine/core"
import { CubeIcon } from "@phosphor-icons/react"
import React from "react"
import { useTranslation } from "react-i18next"
import classes from "./catalog.module.css"

type Props = {
  src?: string | null
  alt?: string
  /** Icon size for the no-photo panel. Card thumbs want a larger mark than list rows. */
  iconSize?: number
  /** Show the «Зураггүй» caption under the icon (cards; table thumbs are too small). */
  withCaption?: boolean
}

/**
 * Product photo, contained on a light ground so the whole product shows. A
 * missing or broken photo becomes a quiet «Зураггүй» panel (B14), not a
 * placeholder illustration.
 */
export function ProductThumb({ src, alt = "", iconSize = 28, withCaption = false }: Props) {
  const { t } = useTranslation("order")
  const [failed, setFailed] = React.useState(false)

  React.useEffect(() => setFailed(false), [src])

  if (!src || failed) {
    return (
      <Box className={classes.thumbEmpty} role="img" aria-label={t("catalog.noImage")}>
        <CubeIcon size={iconSize} />
        {withCaption && <Text span fz="var(--nw-fz-body)">{t("catalog.noImage")}</Text>}
      </Box>
    )
  }

  return (
    <Image
      src={src}
      alt={alt}
      fit="contain"
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
      w="100%"
      h="100%"
      bg="white"
    />
  )
}
